module.exports = __webpack_public_path__ + "static/media/ic_ci_b1_myway.cd66a4db.svg";